import { forwardRef, useMemo } from "react";

import { Icons } from "widgets";

import { type Protein } from "../../../../graphql.js";
import { Tile, type TileProps } from "../../../../modules/core/components/Tile.js";
import { ENTITY_TYPE } from "../../../../settings/settings.js";

interface ProteinTileProps extends Pick<TileProps, "type" | "footNote"> {
  protein: Protein;
  hideIcon?: boolean;
}

const ProteinTile = forwardRef<HTMLDivElement, ProteinTileProps>(function ProteinTile(props, ref) {
  const [title, sequenceId] = useMemo(() => {
    // Sorted in the most meaningful order for the user.
    const title = props.protein?.proteinNames?.[0] ?? props.protein?.alternativeName ?? props.protein?.systematicName;
    const sequenceId = props.protein?.sequenceId;

    return title ? [title, sequenceId] : [sequenceId, undefined];
  }, [props.protein]);

  if (props.protein == undefined) return null;

  return (
    <Tile
      title={title}
      subtitle={sequenceId}
      to={`/${ENTITY_TYPE.PROTEIN}/${props.protein.id}`}
      type={props.type !== undefined ? props.type : "Protein"}
      footNote={props.footNote}
      icon={props.hideIcon !== true ? <img src={Icons.Tiles.Entity} width={24} height={30} /> : undefined}
      ref={ref}
    >
      {props.protein.description}
    </Tile>
  );
});

export { ProteinTile };
